exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".cloud-title{\n    padding: 5px 0 0 5px;\n    text-align: left\n  }\n.tag-cloud {\n  text-align: center;\n}\n", ""]);
